import { getIsDebugging } from 'calling-cross-tab-library/utils/getIsDebugging';
import { getInitialAppData } from 'calling-cross-tab-library/appData/constants/InitialAppData';
import { logDebugMessage } from './getCrossTabEmbedDebugger';
import { ConnectionStatusTypes } from 'shared-worker-versioning/lib/types/ConnectionStatuses';
export class _AppDataManager {
  constructor() {
    this.data = {
      appData: getInitialAppData(),
      connectionStatus: ConnectionStatusTypes.UNINITIALIZED
    };
    this.appDataSubscriptions = new Set();
    this.connectionStatusSubscriptions = new Set();
    this.getAppData = () => this.data.appData;
    this.getConnectionStatus = () => this.data.connectionStatus;
    this.setAppData = (appData, connectionStatus) => {
      if (getIsDebugging().messageDebug) {
        logDebugMessage('appData Updated', {
          next: JSON.parse(JSON.stringify(appData)),
          previous: JSON.parse(JSON.stringify(this.data.appData))
        });
      }
      this.data.appData = Object.assign({}, appData);
      this.emitAppDataUpdate();
      if (connectionStatus) {
        this.data.connectionStatus = connectionStatus;
        this.emiteConnectionStatusUpdate();
      }
    };
    this.setConnectionStatus = connectionStatus => {
      this.data.connectionStatus = connectionStatus;
      this.emiteConnectionStatusUpdate();
    };
    this.setWidgetDetails = widgetDetails => {
      this.data.appData = Object.assign({}, this.data.appData, {
        widgetDetails
      });
      this.emitAppDataUpdate();
    };
    this.subscribeToAppData = fn => {
      this.appDataSubscriptions.add(fn);
      return () => {
        this.appDataSubscriptions.delete(fn);
      };
    };
    this.subscribeToConnectionStatus = fn => {
      this.connectionStatusSubscriptions.add(fn);
      return () => {
        this.connectionStatusSubscriptions.delete(fn);
      };
    };
    this.emitAppDataUpdate = () => {
      this.appDataSubscriptions.forEach(fn => fn());
    };
    this.emiteConnectionStatusUpdate = () => {
      this.connectionStatusSubscriptions.forEach(fn => fn());
    };
  }
}
export default new _AppDataManager();